import Vue from "vue";
import Router from "vue-router";
import {isTokenExpired} from "@/untils/authTokenUtils";
import {clearToken} from "../untils/authTokenUtils";
import listings from "../components/listing/listings.vue";
import selectionLayout from "../components/uConnectReservation/selection/selectionLayout.vue";
import selectionFormLayout from "../components/uConnectReservation/form/selectionFormLayout.vue";
import selectionConfirmLayout from "../components/uConnectReservation/confirm/selectionConfirmLayout.vue";
import myConnects from "../components/connects/myConnects.vue";
import conciergeEnquiries from "../components/enquiry/conciergeEnquiries.vue";
import favouritesPropertyListLayout from "../components/myFavourites/favouritesListLayout.vue";
import allFaq from "../components/faq/allFaq.vue";
import viewFaq from "../components/faq/viewFaq.vue";
import createFaq from "../components/faq/createFaq.vue";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);

const router = new Router({
  routes: [
    // Agent
    // {
    //   path: "/login",
    //   name: "login",
    //   component: resolve => {
    //     require(["components/login/index"], resolve);
    //   }
    // },

    // Priate
    {
      path: "/privatelogin",
      name: "privatelogin",
      component: resolve => {
        require(["components/privateLogin/index"], resolve);
      }
    },

    // U-connect and Agent Both have same login page
    {
      path: "/login",
      name: "login",
      component: resolve => {
        require(["components/uConnectLogin/index"], resolve);
      }
    },
    {
      path: "/uConnectRegister",
      name: "uConnectRegister",
      component: resolve => {
        require(["components/register/uConnectRegistration/uConnectRegistrationLayout"], resolve);
      }
    },
    {
      path: "/uconnect/search/results",
      meta: { requireAuthUconnect: true },
      name: "uConnectSearch",
      component: resolve => {
        require(["components/uConnectSearch/searchLayout.vue"], resolve);
      }
    },
    {
      path: "/uconnect/view",
      meta: { requireAuthUconnect: true },
      name: "uConnectView",
      component: resolve => {
        require(["components/uConnectView/viewLayout.vue"], resolve);
      }
    },
    // U-connect SHARE
    {
      path: "/private/uconnect/view",
      meta: { requireAuthUconnectPrivate: true },
      name: "private_uConnectView",
      component: resolve => {
        require(["components/uConnectView/viewLayout.vue"], resolve);
      }
    },
    // U-Connect Reservations - Selection
    {
      path: "/u-connect/property/reservation",
      meta: { requireAuthUconnect: true },
      name: "uConnectSelection",
      component: selectionLayout
    },
    // Private U-Connect Reservations - Selection
    {
      path: "/private/u-connect/property/reservation",
      meta: { requireAuthUconnectPrivate: true },
      name: "uConnectSelectionPrivate",
      component: selectionLayout
    },
    // U-Connect Reservations - Form
    {
      path: "/u-connect/property/form",
      meta: { requireAuthUconnect: true },
      name: "uConnectForm",
      component: selectionFormLayout
    },
    // Private U-Connect Reservations - Form
    {
      path: "/private/u-connect/property/form",
      meta: { requireAuthUconnectPrivate: true },
      name: "uConnectFormPrivate",
      component: selectionFormLayout
    },
    // U-Connect Reservations - Confirmation
    {
      path: "/u-connect/property/reserve/confirm",
      meta: { requireAuthUconnect: true },
      name: "uConnectSelectionConfirm",
      component: selectionConfirmLayout
    },
    // private U-Connect Reservations - Confirmation
    {
      path: "/private/u-connect/property/reserve/confirm",
      meta: { requireAuthUconnectPrivate: true },
      name: "uConnectSelectionConfirmPrivate",
      component: selectionConfirmLayout
    },

    //Common
    // if logged in, then / should go to the dashboard.
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/update",
      name: "update",
      component: resolve => {
        require(["components/login/update"], resolve);
      }
    },
    // {
    //   path: "/forget",
    //   name: "forget",
    //   component: resolve => {
    //     require(["components/login/forget"], resolve);
    //   }
    // },
    {
      path: "/contactus",
      name: "contactus",
      component: resolve => {
        require(["components/contact/contactUsLayout"], resolve);
      }
    },
    {
      path: "/about",
      name: "about",
      component: resolve => {
        require(["components/about/aboutUsLayout"], resolve);
      }
    },
    // {
    //   path: "/how-it-works",
    //   name: "how-it-works",
    //   component: resolve => {
    //     require(["components/howItWorks/howItWorksLayout"], resolve);
    //   }
    // },
    {
      path: "/terms-and-conditions",
      name: "terms-and-conditions",
      component: resolve => {
        require(["components/terms/termsAndConditionsLayout"], resolve);
      }
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: resolve => {
        require(["components/privacyPolicy/privacyPolicyLayout.vue"], resolve);
      }
    },
    {
      path: '/blog',
      name: 'blog',
      component: resolve => {
        require(['components/blog/blogView/blogCardLayout.vue'], resolve)
      }
    },
    {
      path: "/blog/view/:id",
      name: "blogView",
      component: resolve => {
        require(['components/blog/blogView/blogView.vue'], resolve)
      }
    },

    {
      path: "/index",
      meta: { requireAuth: true },
      component: resolve => {
        require(["components/index1"], resolve);
      },

      children: [
        // Agent
        // Default page after logging in
        {
          path: "/",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/dashboard/dashboard.vue"], resolve);
          }
        },
        //lists all u-connect users from the dashboard
        {
          path: "/uconnect",
          name: "uconnect",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/uConnect/uconnect.vue"], resolve);
          }
        },
        {
          // New Advertising Component
          path: "/all-ads",
          name: "all-ads",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/advertising/advertisingLayout.vue"], resolve);
          }
        },
        {
          // New Advertising Component
          path: "/all-blogs",
          name: "all-blogs",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/blog/blogLayout.vue"], resolve);
          }
        },
        {
          // New Advertising Component
          path: "/create-blog",
          name: "create-blog",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/blog/createBlog.vue"], resolve);
          }
        },
        {
          // Create Advertising Component
          path: "/create-ad",
          name: "create-ad",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/advertising/createAdvertising.vue"], resolve);
          }
        },
        {
          // Suburb
          path: "/suburb",
          name: "suburb",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/suburb/suburb.vue"], resolve);
          }
        },
        {
          // Add Suburb
          path: "/addsuburb",
          name: "addsuburb",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/suburb/addSuburb.vue"], resolve);
          }
        },
        {
          // U-Marketing
          path: "/umarketing",
          name: "umarketing",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/uMarketing/uMarketing.vue"], resolve);
          }
        },
        {
          // FAQ
          path: "/faq",
          name: "faq",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/faq/faq.vue"], resolve);
          }
        },
        {
          //get all FAQ's
          path: "/faq/all",
          name: "getAllFaq",
          meta: { requireAuth: true },
          component: allFaq
        },
        {
          //get all FAQ's
          path: "/faq/view",
          name: "viewAllFaq",
          meta: { requireAuth: true },
          component: viewFaq
        },
        {
          //create FAQ
          path: "/faq/create",
          name: "createFaq",
          meta: { requireAuth: true },
          component: createFaq
        },
        {
          //get all FAQ's
          path: "/addFaq",
          name: "addFaq",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/faq/addFaq.vue"], resolve);
          }
        },

        {
          // FAQs
          path: "/faqs",
          name: "faqs",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/faq/FAQs.vue"], resolve);
          }
        },

        {
          // FAQs
          path: "/faqAgencyList",
          name: "faqAgencyList",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/faq/FAQAgencyList.vue"], resolve);
          }
        },

        {
          // FAQs
          path: "/faqUnifiList",
          name: "faqUnifiList",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/faq/FAQUnifiList.vue"], resolve);
          }
        },


        {
          // Dashboard
          path: "/dashboard",
          name: "dashboard",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/dashboard/dashboard.vue"], resolve);
          }
        },

        {
          // Listing Page
          path: "/listings",
          name: "listings",
          meta: { requireAuth: true },
          component: listings
        },

        {
          // Create New Listing
          path: "/createlisting",
          name: "createlisting",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/listing/createNewListing.vue"], resolve);
          }
        },
        {
          // Edit Agent
          path: "/editagent",
          name: "editagent",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/agent/editAgent.vue"], resolve);
          }
        },
        {
          path: "/agencies",
          name: "agencies",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/company/agencies.vue"], resolve);
          }
        },
        {
          path: "/addagency",
          name: "addagency",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/company/addAgency.vue"], resolve);
          }
        },
        {
          path: "/concierge/enquiries",
          name: "conciergeEnquiries",
          meta: { requireAuth: true },
          component: conciergeEnquiries
        },
        {
          path: "/connects/self",
          name: "myConnects",
          meta: { requireAuth: true },
          component: myConnects
        },
        {
          path: "/property/favourites",
          name: "favouritesPropertyListLayout",
          meta: { requireAuth: true },
          component: favouritesPropertyListLayout
        },

        // U-connect
        {
          // Edit Agent
          path: "/editUConnect",
          name: "editUConnect",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/agent/editAgent.vue"], resolve);
          }
        },

        // Common
        {
          // Invoicing
          path: "/invoicing",
          name: "invoicing",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/invoicing/invoicing.vue"], resolve);
          }
        },
        {
          //Profile
          path: "/profile",
          name: "profile",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/agent/agent.vue"], resolve);
          }
        },
        {
          // 公司信息
          path: "/propertyDetail",
          name: "propertyDetail",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/property/propertyDetail.vue"], resolve);
          }
        },
        {
          //Edit Profile
          path: "/editProfile",
          name: "editProfile",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/agent/editAgent.vue"], resolve);
          }
        },

        {
          // Invoicing
          path: "/reporting",
          name: "reporting",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/reporting/reporting.vue"], resolve);
          }
        },
        {
          // User Logs
          path: "/userLogs",
          name: "userLogs",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/userLogs/userLogs.vue"], resolve);
          }
        },
        {
          path: "/addmembership",
          name: "addmembership",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/company/addMembership.vue"], resolve);
          }
        },

        {
          // admin
          path: "/admin",
          name: "admin",
          meta: { requireAuth: true, requireAdmin: true },
          component: resolve => {
            require(["components/admin/admin.vue"], resolve);
          }
        },
        {
          // View Coupons
          path: "/coupon/view",
          name: "viewCoupons",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/coupon/coupon.vue"], resolve);
          },
        },
        {
          path: "/coupon/add",
          name: "addCoupon",
          meta: { requireAuth: true },
          component: resolve => {
            require(["components/coupon/addCoupon.vue"], resolve);
          }
        },
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});


// 路由拦截
router.beforeEach((to, from, next) => {

  const authToken =localStorage.getItem("token")
  const hasPrivateSession = () => !!sessionStorage.getItem("psd")

  // Prevent redirect loops between login pages
  if (from.path === '/uConnectLogin' && to.path === '/login') {
    return next(false) // Stay on uConnectLogin
  }

  if (from.path === '/login' && to.path === '/uConnectLogin') {
    return next(false) // Stay on login
  }
  // Handle authentication checks with clear precedence
  if (to.meta.requireAuthUconnectPrivate) {
    if (!hasPrivateSession()) {
      const { pid, publicFlag, sessionId } = to.query
      Object.entries({
        unifi_pid: pid,
        unifi_publicFlag: publicFlag,
        unifi_sessionId: sessionId
      }).forEach(([key, value]) => sessionStorage.setItem(key, value))
      return next("/privateLogin")
    }
  } else if (to.meta.requireAuthUconnect) {
    if (!authToken || isTokenExpired(authToken)) {
      clearToken()
      return next("/login")
    }
  } else if (to.meta.requireAdmin) {
    const role = localStorage.getItem("role");
    if (role !== "1") {
      return next("/dashboard");
    }
  } else if (to.meta.requireAuth) {
    if (!authToken || isTokenExpired(authToken)) {
      clearToken()
      return next("/login")
    }
  }

  next()
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js